// extracted by mini-css-extract-plugin
export var description = "index-module--description--6FvvH";
export var educationStory = "index-module--educationStory--ezlXf";
export var inner = "index-module--inner--+PS1Y";
export var logo = "index-module--logo--PABDE";